import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_AUTH_API_BASE_URL,
  client_id: "dashboard",
  redirect_uri: `${import.meta.env.VITE_CLIENT_URL}/callback`,
  post_logout_redirect_uri: `${import.meta.env.VITE_CLIENT_URL}/`,
  scope: "openid profile roles offline_access",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
